export const perspectiveTypes = {
    TOGGLE_AUTO_REFRESH: 'TOGGLE_AUTO_REFRESH',
}
